(function(app) {

    app.provider("accountRelationshipApi",
        [
            function() {
                this.$get = [
                    "crmApiGateway", function(crmApiGateway) {
                        var service = {};

                        service.get = function(relationshipId) {
                            return crmApiGateway.get(`/AccountRelationships/${relationshipId}`);
                        }

                        service.getInvestmentAccountRelationships = function(accountId) {
                            return crmApiGateway.getArray(`/InvestmentAccounts/${accountId}/AccountRelationships`);
                        }

                        service.getInsuranceAccountRelationships = function(accountId) {
                            return crmApiGateway.getArray(`/InsuranceAccounts/${accountId}/AccountRelationships`);
                        }

                        service.updateBeneficiaryPercentage = function(relationshipId, relationship) {
                            return crmApiGateway.put(`/AccountRelationships/${relationshipId}/BeneficiaryPercentage`, relationship);
                        }

                        service.createAccountRelationship = function(relationship) {
                            return crmApiGateway.post("/AccountRelationships", relationship);
                        }

                        service.deleteAccountRelationship = function(relationshipId) {
                            return crmApiGateway.delete(`/AccountRelationships/${relationshipId}`);
                        }

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line